/** Shopify CDN: Minification failed

Line 73:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 74:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 83:12 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 89:10 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 99:7 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 107:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 108:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 113:10 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 61:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 62:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 71:12 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 77:10 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 87:7 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 95:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 96:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 101:10 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 49:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 50:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 59:12 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 65:10 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 75:7 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 83:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 84:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 89:10 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 37:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 38:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 47:12 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 53:10 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 63:7 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 71:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 72:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 77:10 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 25:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 26:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 35:12 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 41:10 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 51:7 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 59:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 60:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 65:10 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 13:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 14:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 23:12 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 29:10 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 39:7 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 47:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 48:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 53:10 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach(animation => animation.play());
    } else {
      this.animations.forEach(animation => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);
  }
}

customElements.define('header-menu', HeaderMenu);
